import { isValid, UTCDate } from '@/utils/dates';

type GetPaidInvoiceRowDateArgs = {
  fspDate?: Date;
  dueDate?: string;
};

export const getPaidInvoiceRowDate = ({ fspDate, dueDate }: GetPaidInvoiceRowDateArgs) => {
  if (fspDate && isValid(new UTCDate(fspDate))) {
    return fspDate;
  }

  if (dueDate && isValid(new UTCDate(dueDate))) {
    return new UTCDate(dueDate);
  }

  return undefined;
};
